module.exports = __webpack_public_path__ + "img/gggl.f708f030.svg";